import { useEffect, useState } from "react";
import styles from "./TableInvestments.module.css";
import "./TableInvestments.css";
import BadgesProjects from "../BadgesProjects/BadgesProjects/BadgesProjects";
import { PageDetailInvestments } from "../../pages/PageDetailInvestments/PageDetailInvestments";
import { IconBoxDevice } from "../Icons/Icons";
import { formatCurrencyCOP } from "../../helpers/FormatNumber";
import { INVERSIONES_USUARIO } from "../../constants/mockData";

const TableInvestments = ({ type, mas = false }) => {
  const [inversion, setInversion] = useState({ showDetail: false, data: null });
  const [data, setData] = useState([]);

  useEffect(() => {
    const mockInversiones = INVERSIONES_USUARIO.map((inv) => ({
      ...inv,
      rendimientos: inv.rendimientos_acumulados,
    }));

    if (type === "grouped") {
      const agrupadas = Object.values(
        mockInversiones.reduce((acc, inv) => {
          const fondoId = inv.fondoInfo.id || inv.fund;
          if (!acc[fondoId]) {
            acc[fondoId] = { ...inv };
          } else {
            acc[fondoId].invested_amount += inv.invested_amount;
            acc[fondoId].rendimientos += inv.rendimientos;
            acc[fondoId].unidades += inv.unidades;
          }
          return acc;
        }, {}),
      );
      setData(agrupadas);
    } else {
      setData(mockInversiones);
    }
  }, [type]);

  const openModal = (tipo, fondo) => {
    console.log("Abrir modal", tipo, fondo);
  };

  const DetailInvestment = (_data) => {
    setInversion({ showDetail: true, data: _data });
  };

  const tituloTabla =
    type === "grouped" ? "Inversiones por vehículo" : "Mis inversiones";

  return (
    <div className="table-investments">
      {inversion.showDetail ? (
        <PageDetailInvestments
          data={inversion.data}
          setSelectedInvestment={setInversion}
        />
      ) : (
        <>
          <div className="table-title">{tituloTabla}</div>
          <div className={styles.tableViewNewInvoice}>
            <div className="table-responsive">
              <table className="table table-borderless">
                <thead>
                  <tr className="head border-top-0">
                    <th>Vehículo de Inversión</th>
                    <th>Gestor</th>
                    <th>Administrador</th>
                    <th>Inversión inicial</th>
                    <th>Invertido</th>
                    <th>Unidades</th>
                    <th>Rendimientos</th>
                    {type === "detailed" && <th>Acciones</th>}
                    {mas && <th>Ver más</th>}
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, i) => (
                    <tr key={i} className="row-component-investments">
                      <td className="col-component-investments">
                        <div className="d-flex align-items-center">
                          <div className="td-img">
                            <IconBoxDevice colorIcon="#019fc5" />
                          </div>
                          <div className="td-txt">
                            <div>{item.fondoInfo.name}</div>
                          </div>
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="badge">
                          <BadgesProjects
                            className=""
                            text={item.fondoInfo.gestor}
                          />
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="badge">
                          <BadgesProjects
                            className=""
                            text={item.fondoInfo.administrador}
                          />
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="center col-fecha-inversion">
                          {item.created_at?.split(" ")[0]}
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="center col-invertido">
                          {formatCurrencyCOP(item.invested_amount) ?? "$0"}
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="center col-propiedad">
                          {item.unidades ?? "0"}
                        </div>
                      </td>
                      <td className="col-component-investments">
                        <div className="center col-rendimientos">
                          {formatCurrencyCOP(item.rendimientos) ?? "$0"}
                        </div>
                      </td>
                      {type === "detailed" && (
                        <td>
                          <button
                            className="btn btn-sm btn-link text-primary"
                            onClick={() => openModal("detalle", item)}
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-link text-warning"
                            onClick={() => openModal("compra", item)}
                          >
                            <i className="bi bi-cart"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-link text-success"
                            onClick={() => openModal("venta", item)}
                          >
                            <i className="bi bi-cash-stack"></i>
                          </button>
                        </td>
                      )}
                      {mas && (
                        <td>
                          <button
                            className="btn btn-sm btn-link"
                            onClick={() => DetailInvestment(item)}
                          >
                            <i className="bi bi-three-dots"></i>
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TableInvestments;
